import axios from 'axios';

import { API_ANALYTICS_EVENTS } from './apiConst';
import { getLogger } from '../logger';

const debug = getLogger('analyticsApi');

export const trackAnalyticsEvent = payload => {
  // silentAuthError: un 401 aquí no debe disparar el flujo global de logout/sesión-caducada
  // (interceptors/responseService.jsx) — es una llamada de telemetría fire-and-forget.
  return axios.post(API_ANALYTICS_EVENTS, payload, { silentAuthError: true }).catch(err => {
    debug.error('[trackAnalyticsEvent] error tracking analytics event %s', err);
  });
};

const CATALOG_RESOURCE_ID_FIELDS = Object.freeze({
  book: 'bookId',
  unit: 'unitId',
  lesson: 'lessonId'
});

/**
 * Builds the onAnalyticsEvent callback of the smart-components Catalog for a classroom.
 * The previewed book, unit or lesson is sent in its own id field; any other type only as activityType.
 */
export const trackCatalogAnalyticsEvent = classId => (event, { context, activityId, resourceType } = {}) => {
  const idField = CATALOG_RESOURCE_ID_FIELDS[resourceType];
  return trackAnalyticsEvent({
    event,
    classId,
    context,
    status: 'success',
    ...(idField && activityId ? { [idField]: activityId } : {}),
    ...(resourceType ? { activityType: resourceType } : {})
  });
};
